import { Button, RadioButtonList } from "@monsterindia/global-ui-components";
import React from "react";

import { useProfileData } from "@/components/settings/contents/profileSettings";

const DisableReasonForm: React.FC<DisableReasonFormProps> = ({
  isMobile,
  handleModal,
  handleTurnOffBtn,
  profileDisableReason,
  eventFunctionHandler,
}) => {
  const { infoPopUpMainHeadingMessage, profileHeading, reasons } =
    useProfileData?.profileAutoUpdate || {};

  const disableReasonOptions = (reasons ?? []).map((reason) => ({
    value: reason?.value ?? "unknown",
    id: reason?.id ?? "no-id",
    displayName: (
      <div className="flex h-[55px] flex-col items-start justify-start gap-1 pb-0 pt-4">
        <div className="inline-flex items-center justify-start gap-2">
          <div className="text-sm font-medium leading-tight text-gray-900">
            {reason?.title ?? "No title provided"}
          </div>
        </div>
        <div className="inline-flex items-start justify-start gap-2 self-stretch">
          <div className="shrink grow basis-0 text-xs font-normal leading-none text-gray-600">
            {reason?.description ?? "No description available"}
          </div>
        </div>
      </div>
    ),
  }));

  return (
    <div
      className={`pb-20 ${isMobile ? "w-full" : "max-h-[320px] max-w-[360px]"}`}
    >
      {isMobile && (
        <>
          <div className="px-4 py-2 text-base font-bold">{profileHeading}</div>
          <div className="bg-border-moderate h-[1px] w-full"></div>
        </>
      )}
      <div className="px-4 py-3">
        <div className="text-base font-bold leading-normal text-gray-900">
          {infoPopUpMainHeadingMessage}
        </div>
        <RadioButtonList
          options={disableReasonOptions}
          layout="col"
          size="large"
          errorLabel="Error message goes here and can wrap if it is too long!"
          eventChangeHandler={eventFunctionHandler}
        />
      </div>
      <div className="fixed bottom-1 flex w-full justify-around gap-3 rounded-bl-2xl rounded-br-2xl bg-white px-2 py-1">
        <Button
          onClick={handleModal}
          label="Keep Profile Auto Update"
          modifier="secondary"
        />
        <Button
          onClick={handleTurnOffBtn}
          label="Disable"
          modifier="primary"
          size="lg"
          className="px-10"
          disabled={!profileDisableReason}
        />
      </div>
    </div>
  );
};

export default DisableReasonForm;
